import React, { useState, useContext } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate, Link } from 'react-router-dom';
import AuthContext from '../../context/AuthContext';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import bliveLogo from '../../assets/blive-logo.png';

const LoginPage = () => {
  const { register, handleSubmit, formState: { errors } } = useForm();
  const navigate = useNavigate();
  const { login } = useContext(AuthContext);
  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [loginError, setLoginError] = useState('');

  const onSubmit = async (data) => {
    setIsLoading(true);
    setLoginError('');

    const result = await login(data);
    if (result.success) {
      navigate('/admin/dashboard');
    } else {
      setLoginError(result.error || 'Invalid credentials');
    }
    
    setIsLoading(false);
  };

  return (
    <div className="vh-100 d-flex justify-content-center align-items-center bg-light" style={{ backgroundImage: 'radial-gradient(#e1dfd5 1px, transparent 1px)', backgroundSize: '20px 20px' }}>
      <div className="card custom-card border-0 shadow-lg" style={{ width: '100%', maxWidth: '450px', borderRadius: '16px' }}>
        <div className="card-body p-5">
          <div className="text-center mb-4">
            <img 
              src={bliveLogo} 
              alt="b:live Logo" 
              className="mb-3 mx-auto d-block"
              style={{ width: '180px', height: 'auto', objectFit: 'contain' }}
            />
            <h4 className="fw-bold text-dark mb-1">Admin Portal</h4>
            <p className="text-muted small">Sign in to manage recruitment drives</p>
          </div>

          {loginError && (
            <div className="alert alert-danger py-2 small mb-4" role="alert">
              {loginError}
            </div>
          )}

          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="mb-4">
              <label className="form-label fw-semibold text-dark">Email Address</label>
              <input 
                type="email" 
                className={`form-control p-3 bg-light border-0 ${errors.email ? 'is-invalid' : ''}`} 
                placeholder="admin@techcorp.com"
                {...register('email', { required: 'Email is required' })} 
              />
              {errors.email && <div className="invalid-feedback">{errors.email.message}</div>}
            </div>

            <div className="mb-4 position-relative">
              <label className="form-label fw-semibold text-dark">Password</label>
              <div className="position-relative">
                <input 
                  type={showPassword ? 'text' : 'password'} 
                  className={`form-control p-3 bg-light border-0 pe-5 ${errors.password ? 'is-invalid' : ''}`} 
                  placeholder="Enter password"
                  {...register('password', { required: 'Password is required' })} 
                />
                <button 
                  type="button" 
                  className="btn btn-link text-muted position-absolute end-0 top-50 translate-middle-y text-decoration-none"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? <FaEyeSlash /> : <FaEye />}
                </button>
              </div>
              {errors.password && <div className="text-danger small mt-1">{errors.password.message}</div>}
            </div>

            <button 
              type="submit" 
              className="btn btn-primary-custom w-100 p-3 fw-bold rounded-pill shadow-sm mt-2 d-flex justify-content-center align-items-center gap-2"
              disabled={isLoading}
            >
              {isLoading && <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>}
              {isLoading ? 'Signing In...' : 'Sign In'}
            </button>
            <div className="text-center mt-3">
              <Link to="/admin/register" className="small text-decoration-none">Create Account</Link>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
